import { plpCleverTapEvents } from "../constants/pageConstants/plpConstants";
import { PageTypes } from "../utils/fnpPageType";

export const cleverTapCommonEvents = {
  pageViewed: "Page Viewed",
  homePageViewed: "Home Page Viewed",
  storeViewed: "Store Viewed",
  micrositePageViewed: "Microsite Page Viewed",
  pdpPageViewed: "PDP Page Viewed",
  loginPageViewed: "Login Page Viewed",
  googleLoginSelected: "Google Login Selected",
  emailEntered: "Email Entered",
  registrationViewed: "Registration Page Viewed",
  regisDetEnter: "Registration Detail Entered",
  otpVerfViewed: "OTP Verification Viewed",
  otpVerfDone: "OTP Verification Done",
  verifyOtpClicked: "Verify OTP Clicked",
  resendOtpSelected: "Resend OTP Selected",
  resendOtpChannelsViewed: "Resend OTP Channels Viewed",
  resentOtpClicked: "Resend OTP Clicked",
  loginSuccess: "Login Success",
  registrationSuccess: "Registration Success",
  bannerClicked: "Banner Clicked",
  headerMenuClicked: "Header Clicked",
  searched: "Searched",
  searchSelected: "Search Selected",
  megaMenuClicked: "Megamenu Clicked",
  giftFinderClicked: "Gift Finder Clicked",
  findGiftClicked: "Find Gift Clicked",
  giftFinderPromptsViewed: "Gift Finder Prompts Viewed",
  giftFinderPromptClicked: "Gift Finder Prompt Clicked",
  giftFinderViewed: "Gift Finder Viewed",
  giftFinderQuestionViewed: "Gift Finder Question Viewed",
  giftFinderQuestionAnswered: "Gift Finder Question Answered",
  giftFinderBackClicked: "Gift Finder Back Clicked",
  giftFinderClosed: "Gift Finder Closed",
  giftFinderSearchClicked: "Gift Finder Search Clicked",
  giftFinderPlpFilterUpdated: "Gift Finder PLP Filter Updated",
  bottomNavigationNavIconClicked: "Bottom Navigation Nav Icon Clicked",
  locationClicked: "Location Clicked",
  locationPopupViewed: "Location Popup Viewed",
  locationPopupClosed: "Location Popup Closed",
  locationPincodeSelected: "Location Pincode Selected",
  locationAreaSelected: "Location Area Selected",
  locationRemoved: "Location Removed",
  locationSaved: "Location Saved",
  locationCountrySelected: "Location Country Selected",
  locationCitySelected: "Location City Selected",
  productClicked: "Product Clicked",
  widgetClicked: "Widget Clicked",
  variantSelected: "Variant Selected",
  pageScrolled: "Page Scrolled",
  sortSelected: "Sort Selected",
  filterSelected: "Filter Selected",
  validationViewed: "Validation Viewed",
  addToCartClicked: "Add To Cart Clicked",
  buyNowClicked: "Buy Now Clicked",
  viewCartClicked: "View Cart Clicked",
  messageOnCakeEntered: "Message On Cake Entered",
  nameToPrintEntered: "Name To Print Entered",
  uploadPhotoDone: "Upload Photo Done",
  deliveryTypeSelected: "Delivery Type Selected",
  wantSameDayClicked: "Want Same Day Clicked",
  deliveryPopupViewed: "Delivery Popup Viewed",
  productAvailableDate: "Product Available Date",
  deliveryDateSelected: "Delivery Date Selected",
  deliveryShippingSelected: "Delivery Shipping Selected",
  deliverySlotSelected: "Delivery Slot Selected",
  deliverySaveAndContinue: "Delivery Save And Continue",
  deliveryPopupClosed: "Delivery Popup Closed",
  deliveryCalendarViewed: "Delivery Calendar Viewed",
  deliveryCalendarClose: "Delivery Calendar Closed",
  addonViewed: "Addon Viewed",
  addonPreviewed: "Addon Preview Viewed",
  addonNotViewed: "Addon Popup Not Viewed",
  addonClosed: "Addon Closed",
  addonAdded: "Addon Added",
  addonRemoved: "Addon Removed",
  productRemoved: "Product Removed",
  addonContinueClicked: "Addon Continue Clicked",
  proceedToCheckoutClicked: "Proceed To Checkout Clicked",
  proceedToPayClicked: "Proceed To Pay Clicked",
  fnpCashApplied: "Fnp Cash Applied",
  fnpCashInfoClicked: "Fnp Cash Info Clicked",
  deliveryShippingViewed: "Delivery Shipping Viewed",
  deliveryShippingWithCalendarViewed: "Delivery Shipping Calendar Viewed",
  deliverySlotsViewed: "Delivery Slots Viewed",
  sessionStart: "Custom Session Start",
  pdpImageViewed: "PDP Image Viewed",
  descriptionViewed: "Description Viewed",
  similarCollectionClicked: "Similar Collection Clicked",
  santaPageViewed: "Secret Santa Page Viewed",
  santaSendGiftsClick: "Secret Santa Send Gifts Click",
  santaCreateRoomClick: "Secret Santa Room Created",
  santaAssignedClick: "Secret Santa Assigned Click",
  santaHomeViewed: "Secret Santa Home Viewed",
  santaRevealDateClick: "Secret Santa Reveal Date Clicked",
  appRedirectBannerClosed: "App Redirect Banner Closed",
  payLaterKnowMoreClicked: "Pay Later Know More Clicked",
  payLaterViewed: "Pay Later Viewed",
  allGiftsClicked: "All Gifts Clicked",
  addonTabSelected: "Addon Tab Selected",
  exploreSimilarGiftsClicked: "Explore Similar Gifts Clicked",
  clearCartPopupViewed: "Clear Cart Popup Viewed",
  clearCartPopupClosed: "Clear Cart Popup Closed",
  clearCartClicked: "Clear Cart Clicked",
  customizeNowClicked: "Customize Now Clicked",
  customizationDone: "Customization Done",
  daPageViewed: "DA Page Viewed",
  addNewAddressClicked: "Add New Address Clicked",
  addAddressClicked: "Add Address Clicked",
  newAddressAdded: "New Address Added",
  changeAddressClicked: "Change Address Clicked",
  addressListViewed: "Address List Viewed",
  addressPageViewed: "Address Page Viewed",
  addressLocationSelected: "Address Location Selected",
  currentLocationClicked: "Current Location Clicked",
  pincodeSuggestionViewed: "Pincode Suggestion Viewed",
  pincodeSuggestionApplied: "Pincode Suggestion Applied",
  noLocationSuggestionsFound: "No Location Suggestions Found",
  pincodeManuallyChanged: "Pincode Manually Changed",
  savedAddressSelected: "Saved Address Selected",
  editAddressClicked: "Edit Address Clicked",
  existingAddressEdited: "Existing Address Edited",
  chooseTimeSlotClicked: "Choose Time Slot Clicked",
  deliverySlotExpired: "Delivery Slot Expired",
  quantityClicked: "Quantity Clicked",
  quantityUpdated: "Quantity Updated",
  comboQuantityPopupClicked: "Combo Quantity Popup Clicked",
  exploreAvailableProductsClicked: "Explore Available Products Clicked",
  viewAvailableProductsClicked: "View Available Clicked",
  mergeDeliverySelected: "Merge Delivery Selected",
  resetDeliverySelected: "Reset Delivery Selected",
  freeMessageCardClicked: "Free Message Card Clicked",
  freeMessageCardAdded: "Free Message Card Added",
  freeMessageCardCancelled: "Free Message Card Cancelled",
  couponClicked: "Coupon Clicked",
  couponApplied: "Coupon Applied",
  couponRemoved: "Coupon Removed",
  mobileAddedOnDA: "Mobile Added on DA",
  billSummaryOpen: "Bill summary open",
  billSummaryClosed: "Bill summary closed",
};

export const cleverTapCommonWords = {
  PDP: "PDP",
  HOME: "HOME",
  Microsite: "MICROSITE",
  AutoSuggestions: "AUTOSUGGEST",
  PLP: "PLP",
  LOGIN: "LOGIN",
  userLogin: "UserLogin",
  CART: "CART",
  REGISTRATION: "Registration",
  SINGLE_IMAGE_BANNER: "Single Image Banner",
  SANTA: "SANTA",
  ALL_GIFTS: "ALL GIFTS",
  REMINDER: "REMINDER",
  ALL_OCCASIONS: "ALL OCCASIONS",
  PROFILE: "PROFILE",
  PARTNER: "PARTNER",
  ACCOUNT: "ACCOUNT",
};

export const validationFor = {
  OTP_VERIFICATION: "OTP verification",
  LOCATION_FIELD: "Location Field",
  NAME_TO_PRINT: "Name to Print",
  PERSONALIZED_IMAGE: "Personalized Image",
  OUT_OF_STOCK: "Out of Stock",
  EMAIL_ID: "Email ID",
  NAME: "Name",
  SOMETHING_WENT_WRONG: "Something went wrong",
  OOPS_PAGE_NOT_FOUND: "Oops Page Not Found",
  PRODUCT_IS_OUT_OF_STOCK: "Product is out of stock",
  GIFT_FINDER_NO_RESULTS: "Gift Finder No Results",
};

export const campaignEvents = {
  RENDER_NOTIFICATION_VIEWED: "renderNotificationViewed",
  RENDER_NOTIFICATION_CLICKED: "renderNotificationClicked",
};

export const duplicateCleverTapEvents = {
  [PageTypes.CATEGORY]: ["LP1", "LP2", "LP3"],
  [PageTypes.PRODUCT]: ["P1", "P2", "P3"],
};

export const eventsWithIpAddress = [
  cleverTapCommonEvents?.homePageViewed,
  cleverTapCommonEvents?.pdpPageViewed,
  cleverTapCommonEvents?.customizeNowClicked,
  cleverTapCommonEvents?.customizationDone,
  cleverTapCommonEvents?.daPageViewed,
  plpCleverTapEvents?.PAGE_VIEWED,
];

export const reminderEvents = {
  REMINDER_PAGE_VIEWED: "My Reminders Entry Click",
  RELATIONS_PAGE_VIEWED: "Occasion Reminder Page Viewed",
  OCCASION_REMINDER_FORM_VIEWED: "Occasion Reminder Form Viewed",
  OCCASION_QUICK_ADD_CLICKED: "Occasion Quick Add Clicked",
  REMINDER_BANNER_VIEWED: "Reminder Occasions Event Viewed",
  REMINDER_NUDGE_CLOSED: "My Reminder Nudge Closed",
  VIEW_ALL_PROFILES_CLICKED: "View All Profiles",
  VIEW_ALL_PROFILES_DISMISSED: "View All Profiles Dismiss",
  VIEW_ALL_OCCASIONS_CLICKED: "View All Occasions Clicked",
  ADD_RELATION_CLICKED: "Add Relation Click",
  CUSTOM_RELATION_CREATED_CLICKED: "Custom Relation Created Clicked",
  CUSTOM_RELATION_CREATED: "Custom Relation Created",
  RELATION_NAME_ENTERED: "Relation Name Entered",
  RELATION_DROPDOWN_CLICKED: "Relation Dropdown Clicked",
  AVATAR_SAVED: "Avatar Saved",
  AVATAR_UPLOAD_CLICKED: "Avatar Upload Clicked",
  OCCASION_CARD_CLICKED: "Occasion Card Clicked",
  OCCASION_DATE_SELECTED: "Occasion Date Selected",
  INCLUDE_YEAR_TOGGLED: "Include Year Toggle",
  SAVE_DATE_CLICKED: "Save Date Clicked",
  OCCASION_REMINDER_SAVED: "Occasion Reminder Saved",
  ADD_MORE_OCCASIONS_CLICKED: "Add More Occasions",
  SAVE_MORE_OCCASIONS_CLICKED: "Save More Occasions",
  OCCASION_EDIT_CLICKED: "Occasion Edit Click",
  OCCASION_DELETE_CLICKED: "Occasion Delete Click",
  OCCASION_DELETE_CONFIRMED: "Occasion Delete Confirmed",
  OCCASION_PRODUCT_CLICKED: "Occasion Send Gift Clicked",
  EXPLORE_MORE_CLICKED: "Explore More Clicked",
  PROFILE_VIEWED: "Occasion Profile Viewed",
  PROFILE_EDIT_CLICKED: "Profile Edit Click",
  PROFILE_DELETE_CLICKED: "Profile Delete Click",
  PROFILE_DELETE_CONFIRMED: "Profile Delete Confirmed",
  ADD_FROM_CONTACT_CLICKED: "Occasion Add Contacts",
  ADD_FROM_CALENDAR_CLICKED: "Occasion Add Calendar Clicked",
  INSTALL_APP_NOW_CLICKED: "Install App Now",
  ALL_OCCASIONS_VIEWED: "All Occasions Viewed",
  ALL_OCCASIONS_VIEW_MODE_CHANGED: "All Occasions View Mode Changed",
  ALL_OCCASIONS_MY_REMINDERS_ONLY_VIEWED: "All Occasions My Reminders Only Viewed",
};

/** My Account CleverTap events. Names match fnp-frontend `cleverTapEventsConstants`. */
export const accountCleverTapEvents = {
  pageViewed: "Page Viewed",
  editOrderClicked: "Edit Order Clicked",
  orderEdited: "Order Edited",
  orderDeleted: "Order Deleted",
  notificationSettingsUpdated: "Notification Settings Updated",
  profileSavedClicked: "Profile Saved Clicked",
  accountAddressSaved: "Account Address Saved",
};

/** `details_type` values sent with Order Edited. */
export const accountOrderEditDetailsType = {
  messageCard: "Message Card",
  senderDetails: "Sender Details",
  recipientDetails: "Recipient Details",
  cakeMessage: "Cake Message",
};

export const deliveryAddressCleverTapEvents = {
  PROCEED_TO_PAY_CLICKED: "Proceed To Pay Clicked",
};

export const partnerPageCleverTapEvents = {
  indigo: {
    PAGE_VIEWED: "IndiGo BluChip Page Viewed",
    POPUP_VIEWED: "IndiGo BluChip Popup Viewed",
    LINKED: "IndiGo BluChip Linked",
    DELINKED: "IndiGo BluChip Delinked",
    TNC_CLICKED: "IndiGo BluChip TNC Clicked",
  },
};
